import mixpanelUtils from '@/utils/mixpanel.utils'
import BaseMixpanelTracker from './base.mixpanel-tracker'
import Utils from '@/util'
import { EVENT_CATEGORIES_BY_ROUTE_NAME } from '@/constant/routes'
import { START_PRESENTING } from '@/constant/eventActions/PresentationsEventActions'

class PresentationMixpanelTracker extends BaseMixpanelTracker {
  constructor(presentation, routeName, currentUser) {
    super(presentation)
    this.routeName = routeName
    this.currentUser = currentUser
  }

  getPresentationContext() {
    return mixpanelUtils.getPresentationContext(this.presentation)
  }

  registerPresentationContext() {
    return mixpanelUtils.register(this.getPresentationContext())
  }

  getPresentationSlideCountObject() {
    return Utils.getSlideCountObject(this.presentation)
  }

  getCustomPropsTrackStartPresenting() {
    return {
      ...this.getPresentationContext(),
      ...this.getPresentationSlideCountObject(),
      isAllowAudienceToReviewTheSides: this.presentation && this.presentation.isEnableAudienceReviewSlides,
      isShowAhaSlidesLinkAtTheEndOfTheLastSlide: this.presentation && this.presentation.isEnableAudienceAhaSlideLabel,
      hasUsedAIGeneratedSlides: (this.currentUser && this.currentUser.hasUsedAIGeneratedSlides) || false,
      aiGeneratedSlideCount: (this.presentation && this.presentation.aiGeneratedSlideCount) || 0,
      importedFileAIGeneratedSlideCount:
        (this.presentation && this.presentation.importedFileAIGeneratedSlideCount) || 0,
    }
  }

  trackStartPresenting(eventLabel, eventValue, needMixpanelRegister) {
    const eventCategory = EVENT_CATEGORIES_BY_ROUTE_NAME[this.routeName]
    if (needMixpanelRegister) {
      this.registerPresentationContext()
    }
    const customProps = this.getCustomPropsTrackStartPresenting()

    Utils.mixpanelTracking(
      eventCategory,
      START_PRESENTING,
      eventLabel,
      eventValue,
      customProps,
    )
  }
}

export default PresentationMixpanelTracker
